import React from 'react';
import successTickGreenMarkIcon from '../../../assets/images/success-tick-green-mark.svg';
import { Button } from '../../library/Button';
import { SuccessContainer, SuccessTitle } from './ProfilePictureUpload.styles';

/**
 * Standalone confirmation screen shown once a photo has been submitted and
 * enrolled successfully. Replaces the checklist/preview stage entirely.
 */
function PhotoUploadSuccess({ onClose, title = 'Profile Photo Uploaded Successfully', children }) {
    return (
        <SuccessContainer>
            <img
                src={successTickGreenMarkIcon}
                alt="Profile photo uploaded successfully"
                style={{ width: '178px', height: '178px', objectFit: 'contain' }}
            />
            <SuccessTitle>{title}</SuccessTitle>
            {children ?? (
                <Button type="button" onClick={onClose}>
                    <i className="fal fa-times"></i> Close
                </Button>
            )}
        </SuccessContainer>
    );
}

export default PhotoUploadSuccess;
